import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/close_icon_small.svg';
const Close = () => React.createElement(IconSvg, null);
export default Close;
